import { UseFormMethods } from 'react-hook-form';
import { Dispatch, SetStateAction } from 'react';
import { apolloClient } from '@lib/apollo';
import {
  INSERT_STUDENT_REQUEST_MESSAGE,
  insert_student_request_messageMutation,
  insert_student_request_messageMutationVariables,
} from '@app-types/graphql-types';
import { AddToast } from 'react-toast-notifications';
import { logError } from '@lib/logger';

type StudentRequestMessageOnSendArgs = {
  message: string;
  reset: UseFormMethods['reset'];
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  studentId?: number;
  userId?: string;
  studentRequestId: number;
  addToast: AddToast;
};

export const studentRequestMessageOnSend = async ({
  message,
  reset,
  setIsLoading,
  studentId,
  userId,
  studentRequestId,
  addToast,
}: StudentRequestMessageOnSendArgs): Promise<void> => {
  try {
    setIsLoading(true);

    await apolloClient.mutate<insert_student_request_messageMutation, insert_student_request_messageMutationVariables>({
      mutation: INSERT_STUDENT_REQUEST_MESSAGE,
      variables: {
        objects: [
          {
            content: message,
            studentId,
            userId: userId || null,
            studentRequestId,
          },
        ],
      },
    });

    reset();
    setIsLoading(false);
  } catch (error) {
    addToast('Error. Something went wrong. Please try again.', {
      appearance: 'error',
      autoDismiss: true,
    });

    setIsLoading(false);

    logError(error);
  }
};
